import { clsx } from '@appvantageasia/core-utils';
import useMediaQuery from '@/utils/useMediaQuery';

const MenuBar = ({
    collapsed,
    setCollapsed,
    noSubMenu,
}: {
    collapsed: boolean;
    setCollapsed: (value: boolean) => void;
    noSubMenu: boolean;
}) => {
    const isDesktop = useMediaQuery('(min-width: 1280px)');

    const menuIcon = (
        <div
            className={clsx(
                'flex h-4 w-5 origin-center transform flex-col justify-between overflow-hidden transition-all duration-300'
            )}
        >
            <div
                className={clsx(
                    'bg-card-foreground h-0.5 w-7 origin-left transform transition-all delay-150 duration-300'
                )}
            />
            <div className={clsx('bg-card-foreground h-0.5 w-7 transform rounded transition-all duration-300')} />
            <div
                className={clsx(
                    'bg-card-foreground h-0.5 w-7 origin-left transform transition-all delay-150 duration-300'
                )}
            />
        </div>
    );

    if (noSubMenu) {
        if (isDesktop) {
            return menuIcon;
        }

        return (
            <button
                className="group relative cursor-pointer opacity-50 disabled:cursor-not-allowed"
                onClick={() => setCollapsed(!collapsed)}
            >
                {menuIcon}
            </button>
        );
    }

    return (
        <button
            className="group relative cursor-pointer opacity-50 disabled:cursor-not-allowed"
            onClick={() => setCollapsed(!collapsed)}
        >
            <div
                className={clsx(
                    'flex h-4 w-5 origin-center transform flex-col justify-between overflow-hidden transition-all duration-300',
                    {
                        '-translate-x-1.5 rotate-180': collapsed,
                    }
                )}
            >
                <div
                    className={clsx(
                        'bg-card-foreground h-0.5 origin-left transform transition-all delay-150 duration-300',
                        {
                            'w-[11px] rotate-42': collapsed,
                            'w-7': !collapsed,
                        }
                    )}
                ></div>
                <div
                    className={clsx('bg-card-foreground h-0.5 w-7 transform rounded transition-all duration-300', {
                        'translate-x-10': collapsed,
                    })}
                ></div>
                <div
                    className={clsx(
                        'bg-card-foreground h-0.5 origin-left transform transition-all delay-150 duration-300',
                        {
                            'w-[11px] -rotate-43': collapsed,
                            'w-7': !collapsed,
                        }
                    )}
                ></div>
            </div>
        </button>
    );
};

export default MenuBar;
